import { Modal } from "antd";
import React, { useContext, useEffect, useState } from "react";
import {
  MsgError,
  MsgLoading,
  MsgSuccess,
} from "../../../components/Loaders/MessageLoaders";
import DeleteModal from "../../../components/Modal/DeleteModal";
import Table from "../../../components/Table/Table";
import { PkgDetailResType } from "../../../helpers/types/global";
import PkgService from "../../../services/PkgService";
import TabAddPackages from "./TabAddPackages";
import TranslationForm from "../page-categories/TranslationForm";
import PackageTranslationForm from "./PkgTranslationForm";
import LangContext from "../../../context/LanguageContext";

const tableHeaders = [
  {
    id: 1,
    title: "title",
  },
  {
    id: 2,
    title: "starting_price",
  },
  {
    id: 3,
    title: "package_img",
    img: true,
  },
  {
    id: 4,
    title: "day",
  },
  {
    id: 5,
    title: "night",
  },
];

const TabViewPacakges = () => {
  const [data, setData] = useState([]);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  // edit curretn id
  const [currentID, setCurrntID] = useState<string>("");
  // delete current id
  const [currentDeleteID, setCurrntDeleteID] = useState<string>("");

  const [pkgDetailData, setPkgDetailData] = useState<PkgDetailResType>();
  const [refreshData, setRefreshData] = useState<boolean>(false);
  const [translationModal, setTranslationModal] = useState<boolean>(false);
  const { lang_id } = useContext(LangContext);

  const handleEditModal = (id: string) => {
    setCurrntID(id);
    MsgLoading();
    PkgService.PkgDetail(id, lang_id)
      .then((res) => {
        console.log(res.data);
        MsgSuccess(res.data.message);
        setPkgDetailData(res.data.data);
        setShowEditModal(!showEditModal);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDelete = async () => {
    try {
      MsgLoading();
      const res = await PkgService.deletePkg(currentDeleteID);
      MsgSuccess(res.data.message);
      setRefreshData(!refreshData);
      setIsDeleteModalOpen(false);
    } catch (error: any) {
      console.log(error);
      MsgError(error.response.data.message || "Can not delete this item !");
    }
  };
  const handleDeleteModal = (id: string) => {
    setCurrntDeleteID(id);
    setIsDeleteModalOpen(true);
  };

  const handleTranslationModal = (id: string) => {
    setCurrntID(id);
    setTranslationModal(true);
  };

  const actionProps = {
    handleEdit: handleEditModal,
    handleDelete: handleDeleteModal,
    translation: handleTranslationModal,
  };
  useEffect(() => {
    try {
      PkgService.AllPkges().then((res) => {
        setData(res.data.data[0]);
      });
    } catch (error) {
      console.log(error);
    }
  }, [refreshData]);
  return (
    <div>
      <Table
        tableHeaders={tableHeaders}
        tableBody={data}
        actions={actionProps}
      />

      {pkgDetailData ? (
        <Modal
          open={showEditModal}
          title={"Edit Package"}
          keyboard
          onCancel={() => setShowEditModal(false)}
          footer={null}
        >
          <TabAddPackages
            EditPkg={pkgDetailData}
            refresh={() => setRefreshData(!refreshData)}
          />
        </Modal>
      ) : (
        ""
      )}
      <DeleteModal
        isDeleteModalOpen={isDeleteModalOpen}
        setIsDeleteModalOpen={setIsDeleteModalOpen}
        handleDelete={handleDelete}
        title="Package"
      />

      {translationModal ? (
        <Modal
          open={translationModal}
          title={null}
          keyboard
          onCancel={() => setTranslationModal(false)}
          footer={null}
          width={"90vw"}
        >
          {" "}
          <div className="text-gray-500">
            <h2 className="font-bold">Add Package translation</h2>
          </div>
          <PackageTranslationForm pkgId={currentID} />
        </Modal>
      ) : (
        ""
      )}
    </div>
  );
};

export default TabViewPacakges;
